// This component manages the "Siting Mode" control panel for the map UI.
// It allows users to toggle siting mode, which enables the selection of a
// new site on the map for Controlled Environment Agriculture (CEA)
// facility analysis. The component also provides feedback and controls for
// removing a selected site.

import * as React from 'react';
import { useState } from 'react';
import Accordion from 'react-bootstrap/Accordion';
import {Badge} from "react-bootstrap";
import Button from "react-bootstrap/Button";

// Props interface for SitingModeControl, describing all required props
// for controlling siting mode and related UI state.
interface SitingModeControlProps {
    style: React.CSSProperties;
    sitingMode: boolean;
    sitingModeSetter: (mode: boolean) => void;
    allowNewSite: boolean;
    allowNewSiteSetter: (allow: boolean) => void;
    showSitingMarkerPopupSetter: (show: boolean) => void;
    cursorSetter: (cursorStyle: string) => void;
    facilityFilterVisibleSetter: (visible: boolean) => void;
    baselineResultsVisibleSetter: (visible: boolean) => void;
    pathwaysResultsVisibleSetter: (visible: boolean) => void;
    // baselineFacilityMetrics: any; // Removed as it's not used
    onAccordionToggle: (isExpanded: boolean) => void; // New prop
}

// SitingModeControl is a React functional component that provides UI
// controls for toggling siting mode and managing site selection on the map.
function SitingModeControl(props: SitingModeControlProps) {
    // Internal state to track which accordion section is open.
    const [internalActiveKey, setInternalActiveKey] = useState<string | null>(null);
    const { sitingMode, allowNewSite, onAccordionToggle } = props; // Removed baselineFacilityMetrics

    // Handler for toggling siting mode on or off. Updates cursor style and
    // visibility of related UI elements based on the new state.
    const onSitingModeSwitchChange = (layerId) => {
        // const sitingMode = structuredClone(props.sitingMode) // No longer needed due to direct prop usage
        // const allowNewSite = structuredClone(props.allowNewSite) // No longer needed
        console.log('switch change')
        console.log('siting mode')
        console.log(props.sitingMode)
        props.sitingModeSetter(!props.sitingMode)
        !props.sitingMode && props.allowNewSite ? props.cursorSetter('crosshair')
            : props.cursorSetter('auto')
        // props.showSitingMarkerPopupSetter(true)
        // If we are turning siting mode on and placing a new site is allowed.
        if (!props.sitingMode && props.allowNewSite) {
            props.showSitingMarkerPopupSetter(false)
            props.facilityFilterVisibleSetter(true)
            // If we are turning siting mode off.
        } else if (props.sitingMode) {
            props.showSitingMarkerPopupSetter(false)
            props.facilityFilterVisibleSetter(false)
            props.pathwaysResultsVisibleSetter(false)
            props.baselineResultsVisibleSetter(false)
            console.log('turning siting mode off')
            // If we are turning siting mode back on without allowing for new site.
        } else
            props.showSitingMarkerPopupSetter(true)
        props.facilityFilterVisibleSetter(true)
    };

    // Handler for the "Remove Site" button. Resets state to allow a new
    // site to be selected and hides results panels.
    const handleRemoveSiteBtnClick = () => {
        console.log('new site btn clicked')
        props.allowNewSiteSetter(true)
        props.cursorSetter('crosshair')
        props.showSitingMarkerPopupSetter(false)
        props.pathwaysResultsVisibleSetter(false)
        props.baselineResultsVisibleSetter(false)
    };

    // Render the accordion UI for siting mode controls, including the
    // siting mode toggle switch and feedback for site selection.
    return (
        <Accordion
            activeKey={internalActiveKey}
            onSelect={(eventKey) => {
                const newActiveKey = internalActiveKey === eventKey ? null : eventKey as string | null;
                setInternalActiveKey(newActiveKey);
                onAccordionToggle(newActiveKey === "0");
            }}
            className="control-panel-accord siting-mode-control-accord"
            style={props.style}
        >
            <Accordion.Item eventKey="0">
                <Accordion.Header>
                    {/* The header for the accordion section. */}
                    {/*<h6>Baseline Impacts & Operational Costs</h6>*/}
                    {/*<strong className={'accord-title'}>Baseline Impacts & Operational Costs</strong>*/}
                    <span className={'accord-title'}>
                            Siting Mode
                        </span>
                    {/*<Badge pill className={'ms-3 ps-3 pe-3'} bg="success">ON</Badge>*/}
                    {/* Display ON/OFF badge for siting mode status. */}
                    {props.sitingMode ?
                        <Badge pill className={'ms-2 p-1'}
                               style={{'width': '40px'}}
                               bg="success">ON</Badge> :
                        <Badge pill className={'ms-2 p-1'}
                               style={{'width': '40px'}} bg="danger">OFF</Badge>
                    }
                </Accordion.Header>
                <Accordion.Body className={'ps-3 pe-3 pt-2 pb-2'}>
                    <div className={'d-flex align-content-center'}>
                        <div className="form-check form-switch">
                            {/* Toggle switch for siting mode. */}
                            <input
                                id="siting-mode-switch"
                                className="form-check-input" type="checkbox"
                                role="switch"
                                checked={props.sitingMode}
                                onChange={
                                    evt => onSitingModeSwitchChange(evt.target.value)
                                }
                            >
                            </input>
                        </div>
                        <div className={'mt-1 mb-1 me-0 ms-3'}>
                            {/* Show instructions or remove button based on siting mode state. */}
                            {props.sitingMode && props.allowNewSite &&
                                <p className={'text-center mb-0'}
                                        style={{border: '1px', lineHeight:'17px'}}>
                                    <strong>
                                        Click on map to select a site
                                    </strong>
                                </p>
                                // <Button
                                //     variant={'outline-secondary'}
                                //     disabled
                                //     style={{
                                //         fontSize: '11px',
                                //         // height: '20px'
                                //         // padding: '2px 12px 2px 12px',
                                //         //     top: '20%',
                                //         //     bottom: '20%'
                                //     }}
                                //     className={
                                //         ''
                                //         // 'ms-4'
                                //     }
                                //     // style={{'marginTop': '-5px'}}
                                //     id="new-site-btn"
                                //     // onClick={newSiteBtnOnClick}
                                // ><small>Choose site on map</small></Button>
                                //
                            }
                            {props.sitingMode && !props.allowNewSite &&
                                <Button
                                    variant={'outline-danger'}
                                    style={{
                                        fontSize: '14px',
                                        paddingLeft: '6px',
                                        paddingRight: '6px',
                                        // height: '20px'
                                        // padding: '2px 12px 2px 12px',
                                        //     top: '20%',
                                        //     bottom: '20%'
                                    }}
                                    className={
                                        ''
                                        // 'ms-4'
                                    }
                                    // style={{'marginTop': '-5px'}}
                                    id="new-site-btn"
                                    onClick={handleRemoveSiteBtnClick}
                                >Remove Site</Button>
                            }
                        </div>
                    </div>
                </Accordion.Body>
            </Accordion.Item>
        </Accordion>
    );
}

export default React.memo(SitingModeControl);
